import { useMemo } from 'react';

import { TrackAssessmentCategory } from '@backrs_ui/common-ui';

import { useGetTrackAssessmentStandardsQuery } from '@backrs_ui/grow-ui/src/redux/trackAssessment/trackAssessment.api';

export const useAcademicStandards = (tenure: string | undefined) => {
  const { data: standards } = useGetTrackAssessmentStandardsQuery(undefined);

  const category: TrackAssessmentCategory | undefined = useMemo(
    () =>
      standards
        ? Array.from(new Map(standards.map((s) => [s.category.id, s.category])).values()).find(
            (c) => c.slug === 'academic-foundations',
          )
        : undefined,
    [standards],
  );

  const filteredStandards = useMemo(() => {
    if (!standards || !tenure) return undefined;

    return standards.filter(
      (s) => s.category.slug === 'academic-foundations' && s.tenure === tenure,
    );
  }, [standards, tenure]);

  return { category, filteredStandards };
};
